import styled from "styled-components";

const BodyWrapper = styled.span`
  position: fixed;
  background-color: white;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 25px 21px;
  left: ${(props) => props.left + "px"};
  top: ${(props) => props.top + "px"};
  z-index: 100;
  min-width: 190px;

  .header {
    display: flex;

    .text {
      width: 50%;
      font-weight: 700;
      font-size: 16px;
      color: #004576;
    }

    .crossButton {
      width: 50%;
      display: flex;
      justify-content: end;
      font-weight: 800;
      color: #004576;
      cursor: pointer;
    }
  }

  .filterFieldName {
    font-weight: 400;
    font-size: 16px;
    color: #3a3a3d;
    margin-top: 15px;
  }

  .body {
    margin-top: 15px;
    max-height: 150px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 10px;
      border: none;
    }
  }

  .footer {
    display: flex;
    gap: 20px;
    margin-top: 20px;

    .clearButton {
      background: #ffffff;
      border: 1px solid #004576;
      border-radius: 4px;
      font-weight: 700;
      font-size: 14px;
      color: #004576;
      width: 100%;
      padding: 10px 0px;
      cursor: pointer;
    }

    .saveButton {
      background: #004576;
      border-radius: 4px;
      border: none;
      width: 100%;
      color: white;
      padding: 10px 0px;
      font-weight: 700;
      font-size: 14px;
      cursor: pointer;
    }
  }
`;

const FilterPopUp = ({
  filterField,
  left,
  top,
  children,
  crossButtonClick,
  clearClick,
  saveClick,
}) => {
  return (
    <BodyWrapper left={left} top={top}>
      <div className="header">
        <div className="text">Filter</div>
        <div className="crossButton" onClick={crossButtonClick}>
          X
        </div>
      </div>
      <div className="filterFieldName">{filterField}</div>
      <div className="body">{children}</div>
      <div className="footer">
        <button className="clearButton" onClick={clearClick}>
          Clear
        </button>
        <button className="saveButton" onClick={saveClick}>
          Save
        </button>
      </div>
    </BodyWrapper>
  );
};

export default FilterPopUp;
